import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, devOnly = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Chargement…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (devOnly && user.role !== "dev") return <Navigate to="/" replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "dev") return <Navigate to="/" replace />;
  return children;
}
